import { CanActivate, Router, UrlTree } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, from } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable()
export class AuthGuardAdminOrManager implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return from(this.guardAdminOrManagerWithCompleteProfile());
  }

  private async guardAdminOrManagerWithCompleteProfile(): Promise<boolean | UrlTree> {
    const { firstValueFrom } = await import("rxjs");
    const { take } = await import("rxjs/operators");
    const userInfo = await firstValueFrom(this.authService.getAuthStatusListener().pipe(take(1)));
    const role = this.authService.getUserRole();
    const allowed = ["superadmin", "admin", "manager"];
    if (!userInfo.isAuthenticated || !role || !allowed.includes(role)) {
      return this.router.createUrlTree(["/auth/unauthorized"]);
    }
    try {
      const profile = await firstValueFrom(this.authService.getProfile());
      if (!this.authService.isProfileComplete(profile)) {
        return this.router.createUrlTree(["/auth/complete-profile"]);
      }
      return true;
    } catch {
      return this.router.createUrlTree(["/auth/unauthorized"]);
    }
  }
}
